import { render, staticRenderFns } from "./stockItemMovementsTable.vue?vue&type=template&id=0965a924&"
import script from "./stockItemMovementsTable.vue?vue&type=script&lang=ts&"
export * from "./stockItemMovementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports